module.exports = __webpack_public_path__ + "static/media/flag-pl.1c548c58.webp";